import { useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getComplexResourceGroups } from 'redux/selectors/experience';
import DrawerLayout from '../drawer_layout';
import { ExperienceContext, searchForBookable } from '../helpers';
import ComplexOptionCard from './complex_option_card';

const ComplexDepartureCoach = () => {
  const history = useHistory();
  const { setDepartureCoach, needUserSelect, setNeedUserSelect } =
    useContext(ExperienceContext);
  const departureCoach = useSelector((state) =>
    getComplexResourceGroups(state)
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const actualDepartures = useMemo(() => searchForBookable(departureCoach), []);

  useEffect(() => {
    // If has 1 departure coach, use that departure coach and goto return coach page
    if (actualDepartures.length === 1) {
      setDepartureCoach(actualDepartures[0]);
      setTimeout(() => history.push('/complex/return-coach'));
    } else {
      setNeedUserSelect((prevState) => ({
        ...prevState,
        departureCoach: true,
      }));
    }
  }, [actualDepartures, setDepartureCoach, history, setNeedUserSelect]);

  // If has 0 departure, display error message
  if (actualDepartures.length === 0) {
    throw new Error('No package, probably input a wrong id.');
  }

  return (
    <DrawerLayout
      back={needUserSelect.departureFerry || needUserSelect.returnFerry}
      productName={departureCoach[0].title}
    >
      {departureCoach.map((resourceGroup) => (
        <div key={resourceGroup.title}>
          {resourceGroup.options.map((optionGroup) =>
            optionGroup.resourceTitle ? (
              <ComplexOptionCard
                key={optionGroup.key}
                title={optionGroup.title}
                onClick={() => {
                  setDepartureCoach(optionGroup);
                  setTimeout(() => history.push('/complex/return-coach'));
                }}
              />
            ) : (
              <div key={optionGroup.title}>
                <h5 className="fw-bold my-4">{optionGroup.title}</h5>
                {optionGroup.options.map((option) => (
                  <ComplexOptionCard
                    key={option.key}
                    title={option.title}
                    onClick={() => {
                      setDepartureCoach(option);
                      setTimeout(() => history.push('/complex/return-coach'));
                    }}
                  />
                ))}
              </div>
            )
          )}
        </div>
      ))}
    </DrawerLayout>
  );
};

export default ComplexDepartureCoach;
